import { type InitOptions } from 'i18next';
import { i18nDefaultLanguageCode, I18nLanguageCode, i18nLanguageCodes } from 'utils';

export type TFunction = (
	namespaces: string | string[],
	params?: Record<string, string | number | undefined | null>
) => string;

export const i18nDefaultNS = 'common' as const;

export function getOptions(
	language: I18nLanguageCode = i18nDefaultLanguageCode,
	ns: string[] = [i18nDefaultNS]
): InitOptions {
	return {
		supportedLngs: i18nLanguageCodes,
		fallbackLng: i18nDefaultLanguageCode,
		lng: language,
		fallbackNS: i18nDefaultNS,
		defaultNS: i18nDefaultNS,
		ns,
	};
}
